import $ from 'jquery'
import Cookies from 'js-cookie'
import { Modal } from 'bootstrap'

const themeSwitch = new BroadcastChannel('themeSwitch')
const body = document.body

const setTheme = (theme) => {
  Cookies.set('theme', theme, { expires: 365 })
  document.documentElement.setAttribute('data-theme', theme)
}

document.querySelector('.theme-switcher').addEventListener('click', () => {
  const theme = document.documentElement.getAttribute('data-theme')
  const newTheme = theme && theme === 'light' ? 'dark' : 'light'
  setTheme(newTheme)
  themeSwitch.postMessage(newTheme)
})

themeSwitch.addEventListener('message', (event) => {
  setTheme(event.data)
})

const setScrollbarWidth = () => {
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  const mainContainer = document.querySelector('#colophon > .container')
  const mainContainerWidth = mainContainer.clientWidth

  body.style.setProperty(
    '--space-width',
    `${(documentWidth - mainContainerWidth) / 2 + 20}px`
  )

  body.style.setProperty('--container-width', `${mainContainerWidth}px`)
  body.style.setProperty('--main-width', `${documentWidth}px`)
}

setScrollbarWidth()
window.addEventListener('load', setScrollbarWidth)
window.addEventListener('resize', setScrollbarWidth)

const jsContainer = () => {
  const containers = document.querySelectorAll('.js-container')
  if (containers) {
    ;[...containers].map((container) => {
      if (!window.matchMedia('(min-width: 1200px)').matches) {
        // container.style.width = ''
        // container.style.marginLeft = ''
        // return
      }

      const gap = 40
      const mainWidth = document.documentElement.clientWidth - gap

      const mainContainer = document.querySelector('#colophon > .container')
      const mainContainerWidth = mainContainer.clientWidth

      container.style.width = `${mainWidth}px`
      container.style.marginLeft = `calc(${-mainWidth / 2}px + 50%)`
      container.style.setProperty(
        '--container-width',
        `${mainContainerWidth}px`
      )
    })
  }
}

jsContainer()
window.addEventListener('load', jsContainer)
window.addEventListener('resize', jsContainer)

$('.vn-btn-terms button').on('click', function (e) {
  e.preventDefault()
  e.stopPropagation()
  e.stopImmediatePropagation()
  window.location.href = $(this).attr('data-url')
})

$('.blog-filter-dropdown').on('change', function () {
  window.location.href = $(this).val()
})

$.ui.autocomplete.prototype._resizeMenu = function () {
  var ul = this.menu.element
  ul.outerWidth(this.element.outerWidth())
}

$('a[href="#cookies"]').on('click', (e) => {
  e.preventDefault()
  window.openAxeptioCookies()
})
